<script>
export default {
  name: 'IconFpBriefcase',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="2.5" y="7.5" width="19" height="13" rx="2" :stroke="color" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M16 20.5V6a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v14.5" :stroke="color" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M2.5 12.5h19" :stroke="color" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
